import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShareWith = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.25 7.75C5.25 5.67893 6.92892 4 8.99999 4C11.0711 4 12.75 5.67893 12.75 7.75C12.75 9.82107 11.0711 11.5 8.99999 11.5C6.92892 11.5 5.25 9.82107 5.25 7.75ZM8.99999 5.5C7.75735 5.5 6.75 6.50735 6.75 7.75C6.75 8.99264 7.75735 10 8.99999 10C10.2426 10 11.25 8.99264 11.25 7.75C11.25 6.50736 10.2426 5.5 8.99999 5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.43127 14.5C4.98709 14.5 3.75 15.7459 3.75 17.37V18.75C3.75 19.1642 3.41421 19.5 3 19.5C2.58579 19.5 2.25 19.1642 2.25 18.75V17.37C2.25 14.9941 4.08399 13 6.43127 13H11.5687C13.916 13 15.75 14.9941 15.75 17.37V18.75C15.75 19.1642 15.4142 19.5 15 19.5C14.5858 19.5 14.25 19.1642 14.25 18.75V17.37C14.25 15.7459 13.0129 14.5 11.5687 14.5H6.43127Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 9.75C14 8.09314 15.3432 6.75 17 6.75C18.6569 6.75 20 8.09315 20 9.75C20 11.4069 18.6569 12.75 17 12.75C15.3432 12.75 14 11.4069 14 9.75ZM17 8.25C16.1716 8.25 15.5 8.92158 15.5 9.75C15.5 10.5784 16.1716 11.25 17 11.25C17.8284 11.25 18.5 10.5784 18.5 9.75C18.5 8.92157 17.8284 8.25 17 8.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 13.75C16.0858 13.75 15.74 14.0858 15.74 14.5C15.74 14.9142 16.0858 15.25 16.5 15.25H18.32C19.3858 15.25 20.25 16.1142 20.25 17.18V18.46C20.25 18.8742 20.5858 19.21 21 19.21C21.4142 19.21 21.75 18.8742 21.75 18.46V17.18C21.75 15.2858 20.2142 13.75 18.32 13.75H16.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconShareWith as ReactComponent };
